import React, { useEffect, useState, useRef } from 'react';
interface FinalCTAProps {
  openModal: () => void;
}
export function FinalCTA({
  openModal
}: FinalCTAProps) {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <div ref={sectionRef} className="relative w-full py-32 md:py-40 flex items-center justify-center overflow-hidden" data-id="element-84">
      {/* Ambient background */}
      <div className="absolute inset-0 z-0" data-id="element-85">
        <div className="absolute top-1/4 left-1/3 w-96 h-96 bg-mint-400/10 dark:bg-mint-500/5 rounded-full filter blur-3xl" data-id="element-86" />
        <div className="absolute bottom-1/4 right-1/3 w-96 h-96 bg-mint-500/10 dark:bg-mint-400/5 rounded-full filter blur-3xl" data-id="element-87" />
      </div>
      <div className={`max-w-3xl mx-auto text-center px-6 md:px-12 relative z-10 transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`} data-id="element-88">
        <h2 className="text-3xl md:text-4xl font-light mb-8" data-id="element-89">
          ready to eat out without the{' '}
          <span className="text-mint-600 dark:text-mint-400" data-id="element-90">stress?</span>
        </h2>
        <p className="text-black/60 dark:text-white/60 text-lg mb-4" data-id="element-91">
          join the waitlist and be first to experience nutrition that just
          works.
        </p>
        <p className="text-black/50 dark:text-white/50 text-sm mb-12" data-id="element-92">
          no spam. just updates on launch and early access.
        </p>
        <button onClick={openModal} className="relative px-8 py-4 bg-mint-500/10 dark:bg-mint-400/10 backdrop-blur-sm rounded-full text-mint-600 dark:text-mint-400 font-light hover:bg-mint-500/20 dark:hover:bg-mint-400/20 transition-all duration-300 group overflow-hidden" data-id="element-93">
          <span className="relative z-10" data-id="element-94">join the waitlist →</span>
          <span className="absolute inset-0 bg-gradient-to-r from-mint-400/20 to-mint-500/20 blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-95" />
        </button>
      </div>
    </div>;
}